module.exports = __webpack_public_path__ + "img/incentive.87e44e7b.svg";